define('SageDotCom/PatternAnimations/animatedCtaButton',["jquery"], function ($) {

    function animatedCtaButton () { }

    animatedCtaButton.prototype.initialize = function () {
        // check if the class for toggling the element exists (added by content author)
        if (jQuery('.cta-button-hide').length) {
            // viewport detecting
            jQuery.fn.isInViewport = function () {
                var elementTop = jQuery(this).offset().top;
                var elementBottom = elementTop + jQuery(this).outerHeight();
                var viewportTop = jQuery(window).scrollTop();
                var viewportBottom = viewportTop + jQuery(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom; 
            };
            jQuery('.page-wrapper').find('.score-button').addClass('button-cta');
            // toggle CTA button visibility
            jQuery(window).on('load resize scroll', function () {
                if (jQuery('.sticky-nav').hasClass("sticky") || !jQuery('.button-cta').isInViewport()) {
                    jQuery('.button-cta').closest('.page-wrapper').find('.score-button.sage-buy-btn').removeClass('cta-button-hide');
                } else {
                    jQuery('.button-cta').closest('.page-wrapper').find('.score-button.sage-buy-btn').addClass('cta-button-hide');
                }
            });
        };
    };

    return new animatedCtaButton();
});
